module.exports = __webpack_public_path__ + "static/media/icon-a-prazo.bafb9081.svg";